<template>
  <PageApplicationMaps :workflowKey="workflowKey" :stepCount="3" @onNavigationNext="onNavigationNext">
    <template #headerLogo>
      <HeaderLogo :src="headerLogo.src" :alt="headerLogo.alt" />
    </template>
    <template #steps>
      <SidebarFields
        tableId="sidebar-table-fields-seeding"
        v-show="paginationStep === 1"
        :selected-rows.sync="selectedFields"
        :customColumnDefinition="columnDefinition"
      />
      <SidebarCreateApplicationMapSeedingSoy ref="createApplicationMap" v-if="paginationStep === 2" />
      <SidebarExportSeeding v-show="paginationStep === 3" :workflowKey="workflowKey" />
      <ModalConfirmation :messages="messages" v-model="visible" @reset="reset" @ignore="stepForward()" />
    </template>
  </PageApplicationMaps>
</template>
<script>
import { mapGetters, mapState } from 'vuex';

import SidebarFields from '@/fields/components/SidebarFields.vue';
import ModalConfirmation from '@/precision-farming/application-maps/components/ModalConfirmation.vue';
import { WorkflowKey } from '@/precision-farming/application-maps/types';
import { availableFeatures } from '@/shared/storeDynamicFeatures';

import columnsSidebarTableFields from '../../../fields/handsontable/columns/applicationMapsSidebarTableFields';
import PageApplicationMaps from '../PageApplicationMaps.vue';
import SaatbauLogo from '../assets/saatbau_Logo_Sondervariante_Kompakt_72dpi_RGB_144.png';
import HeaderLogo from '../components/HeaderLogo.vue';
import SidebarCreateApplicationMapSeedingSoy from './SidebarCreateApplicationMapSeedingSoy.vue';
import SidebarExportSeeding from './SidebarExportSeedingSoy.vue';

export default {
  name: 'PageApplicationMapsSeedingSoy',
  components: {
    PageApplicationMaps,
    SidebarFields,
    HeaderLogo,
    SidebarCreateApplicationMapSeedingSoy,
    SidebarExportSeeding,
    ModalConfirmation,
  },
  data() {
    return {
      workflowKey: WorkflowKey.SEEDING_SOY,
      headerLogo: {
        src: SaatbauLogo,
        alt: 'Saatbau Logo',
      },
      columnDefinition: columnsSidebarTableFields,
      visible: false,
      stepForward: () => {},
    };
  },
  computed: {
    ...mapState('precisionFarming/applicationMaps/seedingSoy', ['paginationStep']),
    ...mapGetters({
      zones: 'precisionFarming/applicationMaps/seedingSoy/zones',
    }),

    currentCompaniesHaveFeature() {
      return this.$store.getters.currentCompaniesHaveFeature(availableFeatures.FEATURE_APPLICATION_MAPS_SEEDING_SOY);
    },

    selectedFields: {
      get() {
        return this.$store.state.precisionFarming.applicationMaps.seedingSoy.selectedFields;
      },
      set(selected) {
        this.$store.commit('precisionFarming/applicationMaps/seedingSoy/setSelectedFields', selected);
      },
    },

    seedRatesExceedThresholds() {
      const lowerThreshold = 300000;
      const upperThreshold = 900000;
      if (
        this.zones.some((zone) => {
          const effectiveSeedRate = zone.manualSeedRate ?? zone.seedRateWithLossCompensation ?? zone.seedRate ?? 0;
          return effectiveSeedRate < lowerThreshold;
        })
      ) {
        return 'lower';
      }
      if (
        this.zones.some((zone) => {
          const effectiveSeedRate = zone.manualSeedRate ?? zone.seedRateWithLossCompensation ?? zone.seedRate ?? 0;
          return effectiveSeedRate > upperThreshold;
        })
      ) {
        return 'upper';
      }
      return null;
    },
    messages() {
      const messages = [];

      const comparativeForm = this.$t(this.seedRatesExceedThresholds === 'upper' ? 'höher' : 'niedriger');
      const part1 = this.$t('Die Saatstärke ist in einer oder mehreren Zonen beträchtlich {comparative} als üblich.', {
        comparative: comparativeForm,
      });
      const part2 = this.$t(
        'Möchtest Du mit diesen Werten fortsetzten oder die Einstellungen auf die empfohlenen Werte zurücksetzen?',
      );

      messages.push(`${part1} ${part2}`);

      return messages;
    },
  },

  methods: {
    async onNavigationNext(stepForward) {
      this.stepForward = stepForward;
      if (this.paginationStep === 2 && this.seedRatesExceedThresholds) {
        this.visible = true;
        return;
      }

      stepForward();
    },
    reset() {
      this.$store.dispatch(`precisionFarming/applicationMaps/seedingSoy/resetManualSeedrates`);
    },
  },
};
</script>
